import { render, staticRenderFns } from "./modalWidget.vue?vue&type=template&id=3f054470&scoped=true"
import script from "./modalWidget.vue?vue&type=script&lang=js"
export * from "./modalWidget.vue?vue&type=script&lang=js"
import style0 from "./modalWidget.vue?vue&type=style&index=0&id=3f054470&prod&scoped=true&lang=css"
import style1 from "./modalWidget.vue?vue&type=style&index=1&id=3f054470&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f054470",
  null
  
)

export default component.exports